export default __webpack_public_path__ + "static/media/uno.fb369f5c.svg";